import { first } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DigestService, UserService, UtilService } from '../services'
import * as moment from "moment";

@Component({
    selector: 'digest-schedule',
    styles: [`
        .big-icon {
            font-size: 20px
        }

        .item-row {
            padding-bottom: 15px;
        }
    `],
    template: `
        <div fxLayoutAlign="space-around center">
            <div *ngIf="!digest.schedule" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
                <spinner></spinner>
            </div>
            <mat-card *ngIf="digest.schedule" fxFlex="80">
                <mat-card-header>
                    <mat-card-title><h2>My Briefing</h2></mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="row" class="item-row">
                            <mat-slide-toggle fxFlexOffset="10" [checked]="digest.schedule?.enabled" (change)="toggleEnabled($event)">{{digest.schedule?.enabled ? 'On' : 'Off'}}</mat-slide-toggle>
                        </div>
                        <div fxLayout="row" class="item-row" style="padding-top: 10px;">
                            <mat-form-field fxFlexOffset="10" fxFlex="80" >
                                <input matInput placeholder="Subject line of email" [(ngModel)]="digest.title" (change)="save()">
                            </mat-form-field>
                        </div>
                        <div *ngIf="digest.schedule" fxLayout="row" class="item-row">
                            <mat-form-field fxFlexOffset="10"  fxFlex="80">
                                <mat-select placeholder="Frequency" [(ngModel)]="digest.schedule.freq" (selectionChange)="frequencyChanged($event)">
                                    <mat-option *ngFor="let freq of frequencies" [value]="freq.value">{{ freq.viewValue }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" *ngIf="digest.schedule.freq === 'WEEKLY'" class="item-row">
                            <div fxLayout="column" fxFlexOffset="10">
                                <span class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Day </span>
                                <div fxLayout="row">
                                    <mat-button-toggle-group [value]="digest.schedule.sendDay" (change)="setDay($event)" multiple>
                                        <mat-button-toggle value="SU">S</mat-button-toggle>
                                        <mat-button-toggle value="MO">M</mat-button-toggle>
                                        <mat-button-toggle value="TU">T</mat-button-toggle>
                                        <mat-button-toggle value="WE">W</mat-button-toggle>
                                        <mat-button-toggle value="TH">T</mat-button-toggle>
                                        <mat-button-toggle value="FR">F</mat-button-toggle>
                                        <mat-button-toggle value="SA">S</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <mat-form-field fxFlexOffset="10" fxFlex="80">
                                <mat-select *ngIf="digest.schedule" placeholder="Timezone" [(ngModel)]="digest.schedule.timeZone" (selectionChange)="save()">
                                    <mat-option *ngFor="let zone of timezones" [value]="zone.value">{{ zone.viewValue }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" style="padding-top:20px;">
                                <div fxFlexOffset="10" class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Time </div>
                                <time-picker fxFlexOffset="10" *ngIf="digest.schedule" [(ngModel)]="digest.schedule.sendTime" (ngModelChange)="save()"></time-picker>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    `
})
export class DigestSchedulerComponent implements OnInit {
    digest: any = {};
    frequencies = this.utilService.digestFrequencies;
    timezones = this.utilService.displayTimezones;

    constructor(private digestService: DigestService, private userService: UserService, private utilService: UtilService) {};

    toggleEnabled(event){
        this.digest.schedule.enabled = event.checked;
        this.save();
    }

    setDay(event){
        this.digest.schedule.sendDay = event.value;
        this.save();
    }

    frequencyChanged(event){
        if(event.value === 'WEEKLY' && !this.digest.schedule.sendDay){
            this.digest.schedule.sendDay = moment().format('dd').toUpperCase();
        }
        this.save();
    }

    save(){
        this.digestService.putDigestConfigurationsForUser(this.userService.getCurrentUser().id, this.digest).pipe(first()).subscribe();
    };

    ngOnInit(){
        this.digestService.getDigestConfigurationsForUser(this.userService.getCurrentUser().id).pipe(first())
            .subscribe(digests => {
                this.digest = digests[0];
                this.digest.schedule.sendTime = moment().set('hour', this.digest.schedule.sendHour).set('minute', this.digest.schedule.sendMinute);
                this.digest.schedule.sendDay = this.digest.schedule.byday;
            });
    };
}
